import { mapState as rootMapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import Select from '@/components/select.vue';
import echart from '@/components/echart.vue';
import getOption, { setYxisInterval, getDimensions } from './option';
import signLog from '../../components/sign-log';

import SearchBar, { SEARCH_CHANGE_TYPE } from '../../mixins/search-bar';
import API from './api';
import { colorBlock } from '../defaultSpacing';
import snapshotPop from '../../components/snapshot-save';
import { normalizeParams } from '@/components/search-result/_center-adaptor/normalizeParams';
import util from '../../common/util';
// import MockData from './cms-mock.js'

import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area'
};
export default {
    i18next: {
        ns: 'md-market-trends',
        // translationResourcesLoaded() {
        //     if (this.isDetailOrNbr && this.params && !util.isSSRServer) {
        //         return this.getDataByCondition(this.params);
        //     }
        // }
    },
    components: { Select, echart },
    mixins: [SearchBar, spaceMixin(), colorMixin()],
    props: {
        type: {
            // validator(value) {
            //     return ['insight'].includes(value);
            // },
            default: ''
        },
        extraTitle: {
            default: ''
        }
    },
    data: function() {
        let config = {
            title: '',
            buttonColor: '',
            snapshotHoverTip: ''
        };
        return {
            ...config,
            setLock: true,
            listingInfo: null, // through cms fetcher get data
            nbrInfo: null, // through cms fetcher get data
            mlsOrgs: [], // through cms fetcher get data
            priceType: 'average',
            chartOption: null,
            titleSize: 24,
            source: null,
            params: null,
            showThisModule: true,
            topSpacing: false,
            btmSpacing: false,
            conditionData: '',
            echartRef: null,
            ...colorBlock
        };
    },
    watch: {
        priceType(newVal, oldVal) {
            if (newVal !== oldVal) {
                let dimensions =  getDimensions(newVal); 
                this.chartOption.dataset.dimensions = dimensions;
                let barData = this.source.map(item => item.count);
                let lineData = this.source.map(item => item[newVal]);
                setYxisInterval(this.chartOption, barData, lineData);
                this.setOptionDelay();
            }
        },
        showThisModule: {
            handler(val) {
                if (!val) {
                    window?.siteAppVm?.$EventBus.$emit(
                        'changeMarketTrendsStatus',
                        {
                            siteid: this.siteId,
                            flag: !val //  Indicates to hide the current module
                        }
                    );
                }
            },
            immediate: true
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "isSearchCenter": store => store.page.searchCenter,
            "isCensusSubdivision": store => store.page?.censusSubdivision || false,
            "currencySymbol": store => store.currency?.symbol,
            "siteId": "siteId",
            'monthSimpleNames': 'monthSimpleNames'
        }),
        ...rootMapState(useUserStore, {
            "user": store => store.user,
            loginStatus: store => store.loginStatus
        }),
        cmpCheckMoreBtn() {
            return (
                util.isEmptyRichtext(this.checkMoreBtn) ? this.$t('md-market-trends.subscribeToMarketUpdates') : this.checkMoreBtn
            );
        },
        priceOptions() {
            return [
                {
                    label: this.$t('md-market-trends.averageSoldPrice'),
                    value: 'average'
                },
                {
                    label: this.$t('md-market-trends.medianSoldPrice'),
                    value: 'median'
                },
                {
                    label: this.$t('md-market-trends.highestSoldPrice'),
                    value: 'highest'
                },
                {
                    label: this.$t('md-market-trends.lowestSoldPrice'),
                    value: 'lowest'
                }
            ];
        },
        defaultCheckMoreBtn() {
            return this.$t('md-market-trends.subscribeToMarketUpdates');
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        checkMoreBtnStyle({ buttonColor }) {
            return buttonColor || this.colorMap?.btnFill ? {
                '--cta-button-bgcolor': buttonColor || this.colorMap?.btnFill
            } : {}
        },
        isInsight() {
            return this.type === 'insight';
        },
        showLock() {
            //save setLock to be true or not save setLock at all which default to be true
            return (
                (this.setLock == true) &&
                this.loginStatus != 1 && // Not logged in
                !this.showNoData
            );
        },
        showNoData() {
            if (this.isInsight) {
                return false; 
            }
            // nbr/ Details page no source、 no other pages location or not source empty state
            return (
                (this.isDetailOrNbr &&
                    (!this.source || this.source.length === 0)) ||
                (!this.isDetailOrNbr && !this.hasLocation)
            );
        },
        marketTitle() {
            const title =
                this.title || this.$t('md-market-trends.marketTrends');
            if (this.listingInfo) {
                let { info = {} } = this.listingInfo;
                return (
                    title +
                    `<span class="zipcode">${this.$t(
                        'md-market-trends.inZipCode',
                        { zipCode: info.zipCode }
                    )}</span>`
                );
            } else if (this.extraTitle) {
                return title + this.extraTitle;
            }
            return title;
        },
        isDetailOrNbr({ page }) {
            let currentPage = page.pageKey || page.page || '';
            return (
                this.listingInfo ||
                this.nbrInfo ||
                [
                    'listing-detail',
                    'listing-detail-sold',
                    'neighborhood'
                ].indexOf(currentPage) > -1
            );
        },

        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        // getDate(timestamp) {
        //     return new Date(Date.now() + timestamp);
        // },
        timeline() {
            const nowDate = new Date();
            nowDate.setMonth(nowDate.getMonth() - 1);
            const nowYear = nowDate.getFullYear();
            let nowMonth = nowDate.getMonth();
            nowDate.setMonth(nowDate.getMonth() - 11);
            const prevYear = nowDate.getFullYear();
            let prevMonth = nowDate.getMonth();
            return `(${this.monthSimpleNames[prevMonth]} ${prevYear} - ${this.monthSimpleNames[nowMonth]} ${nowYear})`;
        },
        TEXT() {
            return {
                //SITE-16247 383 Number mls custom made
                mlsDesc: this.$t('md-market-trends.marketTrendsAreCalculated', {
                    mls:
                        this.listingInfo?.info?.mlsOrgId === 383
                            ? 'MLS®'
                            : 'MLS'
                }),
                unlockDesc: this.$t('md-market-trends.unlockLocalMarketTrends'),
                noDataDesc: this.$t('md-market-trends.pleaseInputAValid')
            };
        },
        avgDiffText() {
            return this.getAvgDiffText(this.conditionData);
        },
        allMlsOrgs({ page }) {
            if (util.inCms) {
                return this.mlsOrgs || [];
            } else {
                return page?.mlsOrgs || [];
            }
        }
    },
    created() {
        //  Need to judge allMlsOrgs Does the array contain showMarketTrends: 1 of mls,  show if there is market trends  module ， If not, hide the module
        const hasShowMarketTrendsItem = this.allMlsOrgs.some(
            item => !!item.showMarketTrends
        );
        // listing-detail  include idx/lp single property(standard)/lp live(standard)
        if (this.isDetailOrNbr) {
            let params;
            if (this.nbrInfo) {
                if (!hasShowMarketTrendsItem) {
                    this.showThisModule = false;
                    return;
                }
                let featureAreaType = NBR_TYPE_NUM?.[this.nbrInfo.featureAreaType] || this.nbrInfo.type;
                params = this.transfer({
                    [featureAreaType]: this.nbrInfo.label
                });
            } else if (this.listingInfo) {
                let { info = {} } = this.listingInfo;
                if (!info.zipCode || !info.mlsOrg?.showMarketTrends) {
                    this.showThisModule = false;
                    return;
                }
                this.changeMLSText(util.getValueByPath(info, 'mlsOrg.id', 0));
                params = this.transfer({
                    zipCode: info.zipCode
                });
            } else {
                this.showThisModule = false;
                return;
            }
            params.changed = false; //  The server caches this request
            this.params = params;
        } else {
            if (!hasShowMarketTrendsItem) {
                this.showThisModule = false;
                return;
            }
            if (this.type !== 'insight') {
                this.watchCondition();
            }
        }
    },
    beforeMount() {
        this.onLngNsLoaded('md-market-trends').then(() => {
            if (this.isDetailOrNbr) {
                this.getDataByCondition(this.params);
            } 
        })
    },
    methods: {
        onEchartRef(e) {
            this.echartRef = e;
        },
        setOptionDelay() {
            this.echartRef?.setOption?.(this.chartOption);
        },
        changeFilterPrice(data) {
            this.priceType = data.value;
            let dimensions = ['month', 'count', data.value];
            this.chartOption.dataset.dimensions = dimensions;
            let barData = this.source.map(item => item.count);
            let lineData = this.source.map(item => item[data.value]);
            setYxisInterval(this.chartOption, barData, lineData);
            this.setOptionDelay();
        },
        showRegisterPop() {
            signLog.register();
        },
        watchCondition() {
            this[SEARCH_CHANGE_TYPE] = condition => {
                condition = util.deepClone(condition);
                this.params = condition;
                if (this.hasLocation) {
                    this.getDataByCondition(condition);
                }
            };
        },
        async getDataByCondition(condition) {
            if (this.isCensusSubdivision) {
                if (this.isSearchCenter) {
                    // 中台, censusSubdivision 类型
                    var conditionObj;
                    if (typeof condition.condition === 'string') {
                        conditionObj = JSON.parse(condition.condition || '{}');
                    } else {
                        conditionObj = condition.condition;
                    }
                    const locationObj = conditionObj.location || {};
                    const cond = {
                        location: {
                            hjCensusSubdivision: locationObj['neighborhood']
                        }
                    };
                    condition = {
                        ...condition,
                        condition: JSON.stringify(cond)
                    };
                } else {
                    // 非中台, censusSubdivision 类型
                    condition = {
                        ...condition,
                        keywordType: 'hjCensusSubdivision'
                    };
                }
            }
            this.conditionData = await API.getData.call(this, condition);
            if (this.type === 'insight') {
                this.params = condition;
            }
            let data = this.conditionData?.data;
            if (data && data.length > 0 && !util.isSSRServer) {
                this.source = data;
                let option = getOption.call(
                    this,
                    this.theme,
                    this.isMobileSize,
                    data,
                    this.priceType,
                    this.currencySymbol, 
                    {
                        lineColor: this.lineColor || this.buttonColor || this.colorMap?.btnFill || '#DBAE77',
                        columnColor: this.columnColor || this.colorMap?.text || '#505050',
                        bgColor: this.bgColor,
                        ...(this.colorMap || {})
                    }
                );
                this.chartOption = option;
                this.setOptionDelay();
            }
        },

        // {mapPath[]}
        clickCheckMoreBtn() {
            if (this.page?.pageKey === 'featured-area-intro') {
                let url = this.nbrInfo?.cityMarketUrl || '';
                if (this.nbrInfo.type === 'neighborhood') {
                    url = this.nbrInfo.nbrMarketUrl
                }
                location.href = url
                return
            }
            if (this.showNoData) {
                return; 
            }
            let params = { ...(this.params || this.searchParams) }; //
            params = {
                ...params,
                ...normalizeParams(
                    this.isSearchCenter,
                    typeof params.condition === 'string'
                        ? JSON.parse(params.condition || '{}')
                        : params.condition,
                    {},
                    { needKey: true }
                )
            };
            if (params) {
                let location = {};
                let locations = this.getLocation(params);
                if (locations.some(l => l.keywordType === 'mapArea')) {
                    location = 'mapArea';
                } else if (locations.some(l => l.keywordType === 'mapPath')) {
                    location = 'Polygon search';
                } else if (locations.some(l => l.keywordType === 'mapRadius')) {
                    location = 'Radius search';
                }
                let fd = new FormData();
                // insight page only gives location
                if (this.type === 'insight' && locations.length > 0) {
                    params = {};
                    if (locations[0].keywordType === 'mapPath') {
                        if (this.isSearchCenter) {
                            params.condition = { location: {} };
                            params.condition.location.mapPath =
                                locations[0].keyword;
                            params.condition = JSON.stringify(params.condition);
                        } else {
                            params.mapPath = locations[0].keyword;
                            params.mapSearch = false;
                        }
                    } else if (locations[0].keywordType === 'mapArea') {
                        params.rect = locations[0].keyword;
                        params.mapSearch = true;
                    } else {
                        if (this.isSearchCenter) {
                            params.condition = { location: {} };
                            locations.map(l => {
                                if (params.condition.location[l.keywordType]) {
                                    params.condition.location[
                                        l.keywordType
                                    ].push(l.keyword);
                                } else {
                                    params.condition.location[l.keywordType] = [
                                        l.keyword
                                    ];
                                }
                            });
                            params.condition = JSON.stringify(params.condition);
                        } else {
                            params.key = locations
                                .map(l => l.keyword)
                                .join(';');
                            params.keywordType = locations
                                .map(l => l.keywordType)
                                .join(';');
                        }
                    }
                }
                delete params.changed;
                fd.append('searchCondition', JSON.stringify(params));
                const options = {
                    params: fd,
                    location:
                        typeof location == 'string'
                            ? location
                            : locations.map(p => p.keyword).join(',')
                };
                if (this.loginStatus == 1) {
                    snapshotPop.open(null, options);
                } else {
                    snapshotPop.openAfterRegister(null, options);
                }
            }
        },
        //  Calculate the first and last month average sold price difference
        getAvgDiffText(data) {
            let result = 0;
            let condition = '';
            if (data.length >= 2) {
                let avg1 = data[0]['average'];
                let avg2 = data[data.length - 1]['average'];
                if (avg1 && avg2) {
                    //  Percentage to one decimal place
                    result = (((avg2 - avg1) * 100) / avg1).toFixed(1);
                }
            }

            //  If it is on the details page
            if (this.listingInfo) {
                let { zipCode = '' } = this.listingInfo.info;
                condition = zipCode;
            } else if (this.nbrInfo) {
                //  if in nbr Page
                condition = this.nbrInfo.label;
            } else {
                //  on other pages
                condition = this.$t('md-market-trends.yourArea');
            }
            if (result > 0) {
                return this.$t('md-market-trends.homeValuesInCondition', {
                    condition,
                    result,
                    arrow: '↑',
                    direction: 'up'
                });
            }
            if (result < 0) {
                return this.$t('md-market-trends.homeValuesInCondition', {
                    condition,
                    result: -result,
                    arrow: '↓',
                    direction: 'down'
                });
            }
            return this.$t('md-market-trends.checkHomeValuesIn', { condition });
        },
        changeMLSText(mlsId) {
            // SITE - 15435;
            if (mlsId == 128) {
                this.TEXT.mlsDesc = this.$t(
                    'md-market-trends.marketTrendsAreCalculated',
                    {
                        mls: 'MLS®'
                    }
                );
            }
        }
    },
    mounted() {
        this.$emit('marketTrendsMounted');
    }
};
